import React from 'react';

import { useIntl } from 'react-intl';

import { POINTS_TRANSLATION_KEY } from './constants';

const PointsText = () => {
  const { formatMessage } = useIntl();

  return <>{formatMessage({ id: POINTS_TRANSLATION_KEY })}</>;
};

export default PointsText;
